"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const GroupedPublishersTable_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderOverclaim/OverclaimView/GroupedPublishersTable"));
const react_1 = __importStar(require("react"));
const AmendSharesOptions_1 = __importDefault(require("@Components/OverclaimView/DisputeOptionSection/AmendSharesOptions"));
const DisputeOptionSection_1 = __importDefault(require("@Components/OverclaimView/DisputeOptionSection"));
const overclaim_share_display_helper_1 = require("@App/helpers/overclaim-share-display-helper");
const contexts_1 = require("@App/contexts");
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const DisputeEmailForm_1 = __importDefault(require("@Components/OverclaimView/DisputeEmailForm"));
const scroll_to_ref_1 = __importDefault(require("@App/helpers/scroll-to-ref"));
const OverclaimDetailTab = ({ onAmend, onClickUploadDocumentsOption }) => {
    var _a, _b, _c;
    const [amendingShare, setAmendingShares] = (0, react_1.useState)(false);
    const [arePublishersValid, setArePublishersValid] = (0, react_1.useState)(true);
    const [emailFormIsOpen, setEmailFormIsOpen] = (0, react_1.useState)(false);
    const scrollRef = (0, react_1.useRef)(null);
    const { overclaimViewStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const totalOverclaim = (0, overclaim_share_display_helper_1.OverclaimShareDisplayHelper)((_a = overclaimViewStore.overclaimViewItem) === null || _a === void 0 ? void 0 : _a.totalKnownShares);
    const isOverclaim = totalOverclaim
        ? totalOverclaim > 0 &&
            ((_b = overclaimViewStore.overclaimViewItem) === null || _b === void 0 ? void 0 : _b.overclaimStatusFilter) !== 'CANCELED' &&
            ((_c = overclaimViewStore.overclaimViewItem) === null || _c === void 0 ? void 0 : _c.overclaimStatusFilter) !== 'MERGED'
        : false;
    return (react_1.default.createElement("div", { id: 'detail-tab' },
        react_1.default.createElement(GroupedPublishersTable_1.default, { allowShareEditing: amendingShare, onValidation: (isValid) => setArePublishersValid(isValid), ref: scrollRef }),
        isOverclaim &&
            (amendingShare ? (react_1.default.createElement(AmendSharesOptions_1.default, { onCancelAmendOption: () => setAmendingShares(false), onConfirmAmendOption: () => onAmend(), disabled: !arePublishersValid })) : (react_1.default.createElement(DisputeOptionSection_1.default, { onClickEmailOption: () => setEmailFormIsOpen(!emailFormIsOpen), isExistingRelinquishment: overclaimViewStore.isExistingRelinquishment, onClickAmendOption: () => {
                    if (scrollRef.current) {
                        (0, scroll_to_ref_1.default)(scrollRef);
                    }
                    setAmendingShares(true);
                }, onClickUploadDocumentsOption: () => onClickUploadDocumentsOption() }))),
        react_1.default.createElement(ModalPortal_1.default, { isOpen: emailFormIsOpen }, emailFormIsOpen && (react_1.default.createElement(DisputeEmailForm_1.default, { onClose: () => {
                setEmailFormIsOpen(false);
            } })))));
};
exports.default = OverclaimDetailTab;
